import * as React from 'react'

import { useCurrentUser } from '~/client/hooks/auth'
import Avatar from '~/client/components/Avatar'

export default function CurrentUserAvatar({...props}){
  const { currentUser } = useCurrentUser()
  return <Avatar
    alt={currentUser?.profile?.name ?? currentUser.email}
    src={currentUser?.profile?.avatar}
    {...props}
  />
}
